
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import { translate, statusColor } from "@/core/services/HelpersFun";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Item1 from "@/layout/header/partials/activity-timeline/Item1.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "kt-otp-management-table",
  components: {},
  props: {
    widgetClasses: String,
  },
  setup() {
    const loading = ref(true);
    const list = ref();
    const pagination = ref();
    const mobile = ref();
    const page = ref(1);
    const route = useRoute();

    const getItems = () => {
      loading.value = true;
      ApiService.query(`/social-media-secretary/${route.params.platform}/${route.params.bot_id}`, {})
        .then(({ data }) => {
          console.log(data);

          // loading.value = false;
          list.value = data.data.social_media_secretaries.data;
          // pagination.value = data.data.codes.pagination;
          loading.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const remove = (id) => {
      loading.value = true;
      ApiService.post(
        `/social-media-secretary/${route.params.platform}/${route.params.bot_id}/${id}/delete`,
        {}
      )
        .then(({ data }) => {
          console.log(data);

          // loading.value = false;
          // list.value = data.data.social_media_secretaries.data;
          // pagination.value = data.data.social_media_secretaries.pagination;
          getItems();
        })
        .catch(() => {
          // loading.value = false;
        });
    };

    const handleSizeChange = (val: number) => {
      return;
    };

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getItems();
    };

    onMounted(() => {
      getItems();
      setCurrentPageBreadcrumbs(translate("دستورات"), []);
    });

    return {
      loading,
      pagination,
      getItems,
      translate,
      statusColor,
      mobile,
      list,
      handleSizeChange,
      handleCurrentChange,
      remove,
      route,
    };
  },
});
